import React, { useState, useRef, useEffect } from "react";
import "./LoginStyle.scss";
import { sendOtpcall } from "../../Store/newUser/NewUserAction";
import { InputText } from "primereact/inputtext";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

const OTPVerification = ({
  newUser,
  handleEnteredNumbers,
  contact,
  fieldsAreFilled,
  setFieldsAreFilled,
  fieldsRequiredError,
  setFieldsRequiredError,
  otpInputTestId,
}) => {
  const inputRefs = useRef(
    Array(6)
      .fill(null)
      .map(() => React.createRef())
  );
  const [inputValues, setInputValues] = useState(Array(6).fill(""));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const resendOTP = () => {
    dispatch(sendOtpcall(contact, newUser, navigate));
  };
  const handleInputChange = (index, value, e) => {
    if (e.keyCode === 8 && index > 0) {
      inputRefs.current[index - 1].current.focus();
    } else if (index < inputRefs.current.length - 1 && value !== "") {
      inputRefs.current[index + 1].current.focus();
    }

    const newValues = [...inputValues];
    newValues[index] = value;
    setInputValues(newValues);

    const allFilled = newValues.every((val) => val !== "");
    setFieldsAreFilled(allFilled);
    setFieldsRequiredError(!allFilled);
  };

  useEffect(() => {
    const enteredNumbers = inputValues.join("");
    handleEnteredNumbers(enteredNumbers);
  }, [inputValues, handleEnteredNumbers]);

  let firstFiveDigits = contact.substring(0, 8);

  const renderInputFields = () => (
    <>
      {inputRefs.current.map((ref, index) => (
        <div className="flex" key={ref}>
          <InputText
            keyfilter="int"
            maxLength="1"
            className={`otp-input text-xl border-round-md border-1 ${
              inputValues[index] && "active"
            }`}
            value={inputValues[index]}
            onChange={(e) => handleInputChange(index, e.target.value, e)}
            onKeyDown={(e) => handleInputChange(index, "", e)}
            ref={ref}
            data-testid={`${otpInputTestId}-${index}`}
          />
        </div>
      ))}
    </>
  );

  return (
    <div className="mb-2">
      <div className="text-blue-900 font-semibold text-4xl ">
        OTP Verification{" "}
      </div>
      <div className="text-500 text-sm w-26rem ">
        Enter OTP received on {firstFiveDigits}***** | Not Received?
        <span
          className="text-blue-900 font-semibold"
          onClick={resendOTP}
          style={{ cursor: "pointer" }}
          title="Resend OTP" >
          {" "}
          Resend OTP
        </span>
      </div>
      <div className="mt-3 flex flex-row flex-wrap gap-3 w-30rem mr-4">
        {renderInputFields()}
      </div>
      {fieldsRequiredError && !fieldsAreFilled && (
        <div className="text-red-500">Fields are required.</div>
      )}
    </div>
  );
};

export default OTPVerification;
